export var getNumberFromSizeString = function (size) {
    var value = size;
    if (typeof size === 'string') {
        if (size.indexOf('px') > 0) {
            var num = size.split('px');
            value = parseInt(num[0], 10);
        }
        else {
            value = parseInt(size, 10);
        }
    }
    var parsedValue = isNaN(value) ? 0 : value;
    return parsedValue;
};
